import { render } from "./xCargoPage.vue?vue&type=template&id=3888adfe&scoped=true"
import script from "./xCargoPage.vue?vue&type=script&lang=js"
export * from "./xCargoPage.vue?vue&type=script&lang=js"

import "./xCargoPage.vue?vue&type=style&index=0&id=3888adfe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3888adfe"]])

export default __exports__